








import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import * as toast from '../../subjects/toast';

@Component
export default class UiToast extends Vue {
  public toasts: any = [];

  public beforeMount(): void {
    toast.get().subscribe((data) => {
      this.toasts = data;
    });
  }

  public onToastClick(seq: number): void {
    toast.hide(seq);
  }

  public getToastClass(status: string): any {
    return {
      success: status === 'success',
      error: status === 'error',
    };
  }
}
